import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { Grid, Typography, Tooltip, IconButton } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Paper from '@material-ui/core/Paper';
import Filter from '../../../components/Filter/components';
import FilterMobile from '../../../components/FilterMobile/components';
import MTable from '../../../components/MTable';
import TableMobile from '../../../components/TableMobile';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { loadSessions, finishSession } from '../store/thunk';
import { loadFilters } from '../../../components/Filter/store/thunk';

import { formatFilters } from '../../../helpers/formatters';

import red from '@material-ui/core/colors/red';

const headers = [
  { title: 'Estabelecimento', field: 'establishmentName' },
  { title: 'Operador', field: 'userName' },
  { title: 'Abertura da sessão', field: 'startDateTime' },
  { title: 'Fechamento da Sessão', field: 'endDateTime' }
];

const width = window.innerWidth;
const tableSessionActionWidth = width < 768 ? 120 : 100;

export default function SessionsRegistration() {
  const dispatch = useDispatch();

  const width = window.innerWidth;
  const isMobile = width < 1024;

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { establishments } = useSelector(state => state.login);
  const { selects, qp } = useSelector(state => state.filters);
  const { list, isLoading, total } = useSelector(state => state.sessions);

  const filters = formatFilters(['situation', 'user'], selects);

  const [sessionsRegistrationPage, setSessionsRegistrationPage] = useState(1);
  const sessionsRegistrationPageSize = 10;
  const sessionsRegistrationPageCount = Math.ceil(total / sessionsRegistrationPageSize);

  const handleLoadSessions = ({ page, qp }) => {
    dispatch(loadSessions({ userId, establishmentId, page, qp, establishments }));
  }

  useEffect(() => {
    handleLoadSessions({ page: 1, qp });
    dispatch(loadFilters(userId, establishmentId));
  }, [userId, establishmentId]);

  useEffect(() => {
    handleLoadSessions({ page: sessionsRegistrationPage, qp });
  }, [sessionsRegistrationPage]);

  const handleFinishSession = rowData => {
    const { sessionId, establishmentId } = rowData;

    const endDateTime = {
      endDateTime: moment().format('YYYY-MM-DD HH:mm:ss')
    }

    const params = { sessionId, userId, establishmentId, endDateTime }

    dispatch(finishSession(params))
      .then(() => handleLoadSessions({ page: sessionsRegistrationPage, qp }));
  }

  return(
    <Paper>
      {isMobile ? (
        <FilterMobile
          filter
          filters={filters}
          handlePageRequest={({ page, qp }) => {
            setSessionsRegistrationPage(1);
            handleLoadSessions({ page, qp });
          }}
        />
      ) : (
        <Filter
          filter
          filters={filters}
          handlePageRequest={({ page, qp }) => {
            setSessionsRegistrationPage(1);
            handleLoadSessions({ page, qp });
          }}
        />
      )}
      {isMobile && (
        <TableMobile
          loading={isLoading}
          data={list?.map(item => {
            return {
              ...item,
              establishmentNameItem: {
                index: 1,
                label: 'Estabelecimento',
                value: <Typography color='textSecondary' variant='body2'>{item?.establishmentName}</Typography>
              },
              startDateTimeItem: {
                index: 2,
                label: 'Início',
                value: <Typography color='textSecondary' variant='body2'>{item?.startDateTime}</Typography>
              },
              endDateTimeItem: {
                index: 3,
                label: 'Fim',
                value: <Typography color='textSecondary' variant='body2'>{item?.endDateTime}</Typography>
              },
              userNameItem: {
                index: 4,
                label: 'Operador',
                value: <Typography color='textSecondary' variant='body2'>{item?.userName}</Typography>
              },
            }
          })}
          actions={[
            {
              action: rowData => {
                if(rowData.endDateTime == 'Usuário Ativo') {
                  const data = { ...rowData };

                  delete data['establishmentNameItem'];
                  delete data['startDateTimeItem'];
                  delete data['endDateTimeItem'];
                  delete data['userNameItem'];

                  return(
                    <Tooltip placement='top' title='Encerrar sessão' enterTouchDelay={0}>
                      <IconButton onClick={() => handleFinishSession(data)}>
                        <FontAwesomeIcon
                          icon={faTimesCircle}
                          color={red[600]}
                          size="xs"
                        />
                      </IconButton>
                    </Tooltip>
                  );
                }
              }
            }
          ]}
        />
      )}
      {!isMobile && (
        <MTable
          loading={isLoading}
          headers={headers}
          data={list}
          textActions="Encerrar Sessão"
          actions={[
            rowData => ({
              icon: () => (
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color={red[600]}
                  size="xs"
                />
              ),
              tooltip: 'Encerrar sessão',
              onClick: (event, rowData) => handleFinishSession(rowData),
              hidden: rowData.endDateTime !== 'Usuário Ativo',
            }),
          ]}
          actionColumnWidth={tableSessionActionWidth}
        />
      )}
      <Grid
        container
        xs={12}
        style={{ padding: 10, display: 'flex', justifyContent: 'flex-end' }}
      >
        <Pagination
          color="primary"
          variant="outlined"
          shape="rounded"
          count={sessionsRegistrationPageCount}
          page={sessionsRegistrationPage}
          onChange={(_, page) => setSessionsRegistrationPage(page)}
        />
      </Grid>
    </Paper>
  );
}